import { Popover } from 'antd'
import { PageCrumbs } from '~/components/business/PageCrumbs'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyIcon } from '~/components/ui/MyIcon'
import { getScrollCaches } from '~/utils'
import styles from './AiHeader.module.css'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import Router from 'next/router'
import classNames from 'classnames'
import QRCode from 'qrcode.react'
import { RemainTimesBtn } from '../RemainTimesBtn'

const socialGroups = [
  {
    url: 'https://u.wechat.com/EAtpjao3EUGgbtP9K1gvk18',
    label: (
      <>
        扫描二维码添加小助手
        <br />
        进AI创作交流群
      </>
    ),
  },
  {
    url: 'https://work.weixin.qq.com/u/vc4186b138aa4211aa?v=4.0.16.19901',
    label: (
      <>
        扫描二维码
        <br />
        添加会员管家入会员群
      </>
    ),
  },
]

export const AiHeader = () => {
  const { validateIsLogin } = useValidateAuth()

  return (
    <PageCrumbs
      title={
        <div className="flex items-center">
          <span>AI创作</span>
        </div>
      }
      dark
      extra={
        <div className="flex items-center">
          <Popover
            placement="bottom"
            overlayClassName={styles.overlayClass}
            content={
              <div className="flex px-4">
                {socialGroups.map((item, index) => (
                  <div
                    key={item.url}
                    className={classNames('w-[172px] text-neutral-500', [
                      index > 0 ? 'ml-4' : '',
                    ])}
                  >
                    <div className="bg-neutral-800 mb-4  border-4 border-neutral-900">
                      <QRCode size={164} value={item.url} />
                    </div>
                    <div className="text-center text-sm">{item.label}</div>
                  </div>
                ))}
              </div>
            }
          >
            <MyBtn $dark>
              <div className="flex items-center">
                <MyIcon icon="weixin" className="text-[20px]" />
                <span className="ml-1">加入社群</span>
              </div>
            </MyBtn>
          </Popover>
          <RemainTimesBtn className="ml-2" />
          <a
            className="ml-2"
            onClick={e => {
              e.preventDefault()
              if (validateIsLogin()) {
                const myMinePath =
                  getScrollCaches()['/ai/mine']?.path || '/ai/mine'
                Router.push(myMinePath)
              }
            }}
          >
            <MyBtn $dark>
              <div className="flex items-center">
                <MyIcon icon="folder-open" className="text-[20px]" />
                <span className="ml-1">我的创作</span>
              </div>
            </MyBtn>
          </a>
        </div>
      }
    />
  )
}
